export const getInitials = (name: string) =>
  name
    .split(' ')
    .splice(0, 2)
    .map((name) => (name.charAt(0) || '').toUpperCase())
    .join('')
